import { ThemeActionTypes } from "./theme.types";

const INITAIL_STATE = {
  direction: "rtl",
};

const themeReducer = (state = INITAIL_STATE, action) => {
  switch (action.type) {
    case ThemeActionTypes.Theme_DIRECTION:
      return {
        ...state,
        direction: action.payload,
      };
    default:
      return state;
  }
};

export default themeReducer;
